import { useSyncExternalStore } from 'react';
import { outboxController, type OutboxSnapshot } from './outbox-controller';

/**
 * Subscribe a component to the outbox state (pending count, online, syncing, unacknowledged
 * permanent failures) via `useSyncExternalStore` — concurrent-safe, no extra re-renders. Drives the
 * offline banner, the "N changes waiting" badge, and the sync-failed toasts.
 */
export function useOutbox(): OutboxSnapshot {
  return useSyncExternalStore(
    outboxController.subscribe,
    outboxController.getSnapshot,
    outboxController.getSnapshot,
  );
}
